import { json } from '@remix-run/node'
/* import { NavLink, useLoaderData } from '@remix-run/react' */
/* import { NavigationMenu, NavigationMenuItem } from '#app/components/navigation/navigation-menu.tsx'
import { Code } from '#app/components/typography/code.tsx' */
import { P } from '#app/components/typography/p.tsx'
import { readSource } from '../sections/sections.server.tsx'
import { Description/* , Features, Source */, type componentProps/* , Usage, Keyboard, Styling, Parts */ } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'NavigationMenu',
}

const component: componentProps = {
	name: 'Navigation Menu',
	shortName: 'NavigationMenu',
	fileName: 'navigation-menu',
	category: 'navigation',
	description: ['A collection of links for navigating websites.'],
	features: [
		'Can be controlled or uncontrolled.',
		'Flexible layout structure with managed tab focus.',
		'Supports submenus.',
		'Optional active item indicator.',
		'Full keyboard navigation.',
		'Exposes CSS variables for advanced animation.',
		'Supports custom timings.',
	],
	keyboard: [
		{ key: 'Space', description: 'When focus is on NavigationMenuTrigger, opens the content.' },
		{ key: 'Enter', description: 'When focus is on NavigationMenuTrigger, opens the content.' },
		{
			key: 'ArrowDown',
			description:
				'When horizontal and focus is on an open NavigationMenuTrigger, moves focus into NavigationMenuContent. Moves focus to the next NavigationMenuTrigger or NavigationMenuLink.',
		},
		{ key: 'ArrowUp', description: 'Moves focus to the previous NavigationMenu.Trigger or NavigationMenuLink.' },
		{
			key: 'ArrowRight',
			description:
				'When vertical and focus is on an open NavigationMenuTrigger, moves focus into its NavigationMenuContent. Moves focus to the next NavigationMenuTrigger or NavigationMenuLink.',
		},
		{
			key: 'ArrowLeft',
			description:
				'When vertical and focus is on an open NavigationMenuTrigger, moves focus into its NavigationMenuContent. Moves focus to the previous NavigationMenuTrigger or NavigationMenuLink.',
		},
		{ key: 'Home', description: 'Moves focus to the first NavigationMenuTrigger or NavigationMenuLink.' },
		{ key: 'End', description: 'Moves focus to the last NavigationMenuTrigger or NavigationMenuLink.' },
		{ key: 'Esc', description: 'Closes open NavigationMenuContent and moves focus to its NavigationMenuTrigger.' },
	],
	parts: [
		{
			name: 'NavigationMenu',
			description: 'Contains all the parts of a navigation menu.',
			props: [
				{ name: 'defaultValue', type: 'string', default: 'No default value', description: 'The default value of the menu.' },
				{ name: 'value', type: 'string', default: 'No default value', description: 'The value of the menu.' },
				{ name: 'onValueChange', type: 'function', default: 'No default value', description: 'The callback when the value changes.' },
				{ name: 'delayDuration', type: 'number', default: '200', description: 'The delay duration in milliseconds.' },
				{ name: 'skipDelayDuration', type: 'number', default: '300', description: 'The skip delay duration in milliseconds.' },
				{ name: 'dir', type: 'enum: "ltr" | "rtl"', default: 'No default value', description: 'The direction of the menu.' },
				{ name: 'orientation', type: 'enum: "horizontal" | "vertical"', default: '"horizontal"', description: 'The orientation of the menu.' },
			],
		},
	],
	usage: `<NavigationMenu>
	<NavigationMenuItem href="/">Home</NavigationMenuItem>
	<NavigationMenuItem href="/store">Store</NavigationMenuItem>
	<NavigationMenuItem href="/about">About Us</NavigationMenuItem>
	<NavigationMenuItem href="/contact">Contact</NavigationMenuItem>
</NavigationMenu>`,
	styling: ``,
}

export const loader = async () => json({ source: await readSource({ category: component.category, fileName: component.fileName }) })

const AlertDialogRoute = () => {
	/* const { source } = useLoaderData<typeof loader>() */
	const { name, description/* , shortName, fileName, features, keyboard, usage, parts, styling */ } = component

	return (
		<>
			<Description name={name} description={description} />
			<P>
				<a href="https://github.com/adobe/react-spectrum/discussions/6441#discussioncomment-9544249" target="_blank" rel="noreferrer" className="link">
					Pending React Aria support
				</a>{' '}
				for the "Disclosure Navigation Menu" pattern.
			</P>
			{/* <Usage usage={usage} shortName={shortName} /> */}
			{/* <Features features={features} />
			<Keyboard keyboard={keyboard} />
			<P className="mt-4">
				<Code>NavigationMenu</Code> should not be confused with <Code>DropDownMenu</Code> or <Code>ContextMenu</Code>, although this primitive shares the name menu in the colloquial
				sense to refer to a set of navigation links, it does not use the{' '}
				<a href="https://www.w3.org/WAI/ARIA/apg/patterns/menubar/" target="_blank" rel="noreferrer" className="underline">
					WAI-ARIA menu role
				</a>
				. This is because menu and menubars behave like native operating system menus most commonly found in desktop application windows, as such they feature complex functionality like
				composite focus management and first-character navigation. The <Code>NavigationMenu</Code> does not.
			</P>
			<P className="mt-4">
				These features are often considered unnecessary for website navigation and at worst can confuse users who are familiar with established website patterns. See the{' '}
				<a href="https://www.w3.org/WAI/ARIA/apg/patterns/disclosure/examples/disclosure-navigation/" target="_blank" rel="noreferrer" className="underline">
					W3C Disclosure Navigation Menu
				</a>{' '}
				example for more information.
			</P>
			<Parts parts={parts} />
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} /> */}
		</>
	)
}

export default AlertDialogRoute
